export default function authReducer(state = {}, { type, payload }) {
  switch (type) {
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/auth.js